module.exports = __webpack_public_path__ + "img/g15.f8aac12d.jpg";